import { render, staticRenderFns } from "./DropdownUser.vue?vue&type=template&id=96590b8a&scoped=true&"
import script from "./DropdownUser.vue?vue&type=script&lang=ts&"
export * from "./DropdownUser.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownUser.vue?vue&type=style&index=0&id=96590b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96590b8a",
  null
  
)

export default component.exports